var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-app",staticStyle:{"background-color":"#ffffff"}},[_c('div',{staticClass:"c-wrapper"},[_c('div',{staticClass:"c-body"},[_c('CContainer',[_c('div',{staticClass:"lds-ripple"},[_c('div'),_c('div'),_c('p',{staticClass:"font-weight-bold text-success"},[_vm._v("กำลังดำเนินการ")])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }